<template>
  <v-tour name="tour" :steps="steps" :options="options" :callbacks="callbacks">
  </v-tour>
</template>

<script>
export default {
  name: "BusinessTourComponent",
  data() {
    return {
      callbacks: {
        onSkip: this.tourStepFinish,
        onFinish: this.tourStepFinish
      },
      options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Cerrar",
          buttonPrevious: "Anterior",
          buttonNext: "Continuar",
          buttonStop: "Finalizar"
        }
      },
      steps: [
        {
          target: "#app",
          content: `
            <h5>Paso 1 de 5</h5>
            <h6>Completa los datos de tu negocio</h6>
            <p>Empieza por la información básica. Luego podrás cargar firma electrónica y establecimientos cuando los tengas a mano.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 2 de 5</h5>
            <h6>Sube tu firma electrónica</h6>
            <p>Es el archivo .p12 emitido por una entidad autorizada. Lo necesitas para emitir y firmar documentos electrónicos válidos ante el SRI.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 3 de 5</h5>
            <h6>Configura tu secuencia</h6>
            <p>¿Vienes de otro sistema de facturación? Define el número desde el que continuarás para no repetir secuenciales.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 4 de 5</h5>
            <h6>Registra tus establecimientos</h6>
            <p>Agrega los puntos de emisión y establecimientos tal como aparecen en tu RUC. Puedes tener varios.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 5 de 5</h5>
            <h6>Pasa a producción cuando estés listo</h6>
            <p>Emite documentos de prueba al SRI y verifica que se autoricen. Cuando todo funcione, activa el ambiente de producción.</p>
          `
        }
      ]
    };
  },
  computed: {},
  methods: {
    tourStepFinish() {
      const userConfigGeneral = {
        is_business_tour_completed: 1
      };
      this.$store.dispatch("userConfigGeneralUpdated", userConfigGeneral);
    }
  },
  mounted() {
    this.$tours["tour"].start();
  }
};
</script>

<style lang="scss" scoped></style>
